/**
 * useSiteSettings — single source of truth for SEO/GEO/contact data.
 *
 * Returns the active SiteSettings record so any component can show the
 * latest email / address / area-served without hardcoding it in each spot.
 *
 * The hook returns SITE_SETTINGS_FALLBACK directly from
 * `src/lib/siteSettings.ts` with no network call. Kept as a hook (not a bare
 * import) so callers don't change and a live config feed can be reintroduced
 * later without touching every consumer.
 */

import { SITE_SETTINGS_FALLBACK } from '../lib/siteSettings';
import type { SiteSettings } from '../lib/types';

export const useSiteSettings = (): SiteSettings => SITE_SETTINGS_FALLBACK;
